import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
} from '@/components/common/skeleton';

const BUBBLE_COUNT = 6;
const BUBBLE_WIDTHS: ReadonlyArray<`${number}%`> = [
  '65%',
  '70%',
  '60%',
  '75%',
  '55%',
  '70%',
];

export const ChatWindowSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <View style={styles.messagesArea}>
      <View style={styles.dateHeaderWrap}>
        <SkeletonBone width={80} height={14} borderRadius={12} />
      </View>
      {Array.from({ length: BUBBLE_COUNT }).map((_, i) => {
        const isAdmin = i % 2 === 1;
        return (
          <View
            key={i}
            style={[
              styles.bubbleRow,
              { justifyContent: isAdmin ? 'flex-end' : 'flex-start' },
            ]}
          >
            <SkeletonBone
              width={BUBBLE_WIDTHS[i % BUBBLE_WIDTHS.length]}
              height={40}
              borderRadius={16}
            />
          </View>
        );
      })}
    </View>
    <View style={styles.inputRow}>
      <SkeletonBone width={24} height={24} borderRadius={12} />
      <View style={styles.inputField}>
        <SkeletonBone width="100%" height={44} borderRadius={12} />
      </View>
      <SkeletonBone width={60} height={44} borderRadius={22} />
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  messagesArea: {
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 16,
    gap: 12,
  },
  dateHeaderWrap: {
    alignItems: 'center',
    marginVertical: 8,
  },
  bubbleRow: {
    flexDirection: 'row',
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  inputField: {
    flex: 1,
  },
});
